import { render, staticRenderFns } from "./EocDraggableTemplate.vue?vue&type=template&id=887a9ef6&"
import script from "./EocDraggableTemplate.vue?vue&type=script&lang=js&"
export * from "./EocDraggableTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports